import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxBadgeComponent } from './components';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxBadgeComponent,
    ],
    exports: [
        AtxBadgeComponent,
    ]
})

export class AtxBadgeModule {}
